import { render, staticRenderFns } from "./steps2.vue?vue&type=template&id=3aa0f9c0&scoped=true&"
import script from "./steps2.vue?vue&type=script&lang=js&"
export * from "./steps2.vue?vue&type=script&lang=js&"
import style0 from "./steps2.vue?vue&type=style&index=0&id=3aa0f9c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa0f9c0",
  null
  
)

export default component.exports